<template>
  <div class="tw-flex tw-flex-none tw-flex-col tw-space-y-1 tw-text-sm md:tw-w-[140px]">
    <div v-for="navItem in navItems" :key="navItem.id">
      <div
        :title="disabledReason"
        :class="{
          'tw-cursor-not-allowed': disabled
        }"
      >
        <router-link
          :to="{
            name:
              navItem.id === activeNavId && !navItem?.routeName
                ? ''
                : (navItem?.routeName ?? navItem?.subNavItems?.[0]?.routeName),
            params: navItem?.params
          }"
          class="tw-block tw-cursor-pointer tw-px-2 tw-py-1 tw-text-xs dark:tw-text-white"
          :class="{
            'tw-font-semibold': navItem.id === activeNavId,
            'tw-pointer-events-none': disabled,
            'tw-rounded tw-bg-slate-100 tw-ring-slate-100 dark:tw-bg-slate-900 dark:tw-ring-slate-900':
              navItem.id === activeNavId && !navItem.subNavItems
          }"
          :title="disabledReason"
          :data-testid="`navigation-${navItem.title}`"
        >
          {{ navItem.title }}
        </router-link>
      </div>
      <template v-if="!hideSubNav && navItem.subNavItems && navItem.id === activeNavId">
        <div v-for="subNavItem in navItem.subNavItems" :key="subNavItem.id" class="tw-ml-2 tw-border-l tw-py-1 tw-pl-3">
          <router-link
            :to="{ name: subNavItem.routeName, params: subNavItem?.params }"
            class="tw-block tw-cursor-pointer tw-px-2 tw-py-1 tw-text-xs dark:tw-text-white"
            :class="{
              'tw-rounded tw-bg-slate-100 tw-ring-slate-100 dark:tw-bg-slate-900 dark:tw-ring-slate-900':
                subNavItem.id === activeSubNavId
            }"
            :data-testid="`sub-navigation-${subNavItem.title}`"
          >
            {{ subNavItem.title }}
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

type NavItem = {
  id: number;
  title: string;
  routeName?: string;
  subNavItems?: NavItem[];
  params?: { [key: string]: string };
};

export default defineComponent({
  name: 'StudioSidebarNav',
  props: {
    navItems: { type: Array as PropType<NavItem[]>, required: true },
    activeNavId: { type: Number, required: true },
    activeSubNavId: { type: Number, default: 0 },
    hideSubNav: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledReason: { type: String, default: '' }
  }
});
</script>
